
import React from "react";
import { FormField as FormFieldType } from "@/components/dashboard/shops/types";
import { FieldToggle } from "./FieldToggle";
import { FieldName } from "./FieldName";
import { FieldControls } from "./FieldControls";

interface FormFieldProps {
  field: FormFieldType;
  isEditing: boolean;
  toggleFieldEnabled: (id: string) => void;
  toggleFieldRequired: (id: string) => void;
  deleteField: (id: string) => void;
  updateFieldName: (id: string, name: string) => void;
  updateFieldType?: (id: string, type: FormFieldType['type']) => void;
}

export const FormFieldComponent: React.FC<FormFieldProps> = ({
  field,
  isEditing,
  toggleFieldEnabled,
  toggleFieldRequired,
  deleteField,
  updateFieldName,
  updateFieldType
}) => {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FieldToggle 
            field={field} 
            isEditing={isEditing} 
            toggleFieldEnabled={toggleFieldEnabled} 
          />
          
          <FieldName 
            field={field} 
            isEditing={isEditing} 
            updateFieldName={updateFieldName} 
          />
        </div>
        
        <FieldControls 
          field={field} 
          isEditing={isEditing} 
          toggleFieldRequired={toggleFieldRequired} 
          deleteField={deleteField} 
          updateFieldType={updateFieldType} 
        />
      </div>
    </div>
  );
};
